import { Box, Container, Grid, Typography } from '@mui/material'
import React from 'react'
import Links from '../Home/Links'
import { Btn1 } from '../StyledComponents';
import { Link } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { Profession } from '../Home/Content';

function Footer() { 
    const pages = [
        {page:"Home",href:"?section=home"},
        {page:"Skills",href:"?section=skill"},
        {page:"Resume",href:"?section=resume"},
        {page:"Works",href:"?section=works"},
        {page:"About",href:"?section=aboutMe"},
        {page:"Contact Me",href:"?section=contact"},
        {page:"Hire Me",href:"?section=contact"},
      ];
      let theme=useTheme();
      
  return (
    <Box pt={3} sx={{
        backgroundColor:'shade.main',
        overflow:"hidden",
    }}>
        <Container>
            <Profession 
                sx={{
                    title:{
                        my:3,
                        textAlign:"center",
                        color: 'secondary.main',
                        fontSize: { xs: "1.4rem", sm: '1.5', md: "2rem" }
                    },
                    caption:{
                        mb:3,
                        textAlign: "center",
                        color: 'shade.light',
                        padding: { xs: "0px 0px", sm: '0px 100px', md: " 0px 200px" },
                        
                    }
                }}
            />
            {/* <Typography my={3}  sx={{
                color:'secondary.main',
                fontSize:{xs:"1.4rem",sm:'1.5',md:"2rem"},
                textAlign:'center'
            }}
            data-aos="fade-up" data-aos-duration="2000"
            >
                Full Stack Developer
            </Typography>
            <Typography mb={3} sx={{
                color:'shade.light',
                padding:{xs:"0px 0px",sm:'0px 100px',md:" 0px 200px"},
                textAlign:"center"
            }}
            data-aos="fade-up" data-aos-duration="2000"
            >
                I'm a full stack developer with a deep love for coding, passionately creating innovative, efficient, and user-friendly web applications that make a difference.
            </Typography> */}
            <Grid container>
                <Grid xs={12} sm={12} md={12}>
                    <Box mb={3} sx={{display:"flex",gap:{xs:"10px",sm:"20px",md:"20px"},justifyContent:"center"}} data-aos="fade-up" data-aos-duration="2000">
                        <Links size={{xs:"20",sm:'30',md:"40"}} color="white" />
                    </Box>
                </Grid>
                <Grid xs={12} sm={12} md={12}>
                    <Box sx={{display:"flex",justifyContent:"space-evenly",flexDirection:{xs:"column",sm:"row",md:"row"},alignItems:"center"}}>
                        {pages.map((obj)=>
                        {
                            return(
                                <Btn1 data-aos="fade-up" data-aos-duration="2000"
                                    key={obj.page}
                                    component={Link}
                                    to={obj.href}
                                    sx={{
                                        color:'primary.main',
                                        '&:hover':{
                                            color:"white"
                                        }

                                    }}
                                >
                                    {obj.page}
                                </Btn1>
                            )
                        })}
                    </Box>
                </Grid>
            </Grid>

            
            
        </Container>
                <Typography
                    sx={{
                        fontSize:"30vw",
                        color:'shade.main',
                        textAlign:"center",
                        lineHeight:"100%" ,
                        transform:"translateY(35%);",
                        width:"100% ",
                        "-webkit-text-stroke": `2px ${theme.palette.shade. light}`,
                    }}
                    
                >
                    Sharief
                </Typography>
    </Box>
  )
}

export default Footer